import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-help-library-preview',
    templateUrl: './help-library-preview.component.html',
    styleUrls: ['./help-library-preview.component.scss'],
    standalone: false
})
export class HelpLibraryPreviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
